import axios from 'axios';
import BaseApi from '@/uptk/core/api/BaseApi';
import { apiAzureUrl } from '@/uptk/core/api/contants';
import { applyFaithfulPatch, utf8Bytes, type FaithfulScope, type FaithfulState, type FaithfulStateRepository } from './contracts';

export class FaithfulConflict extends Error {}
export function createMemoryFaithfulRepository(identity: () => unknown = () => null): FaithfulStateRepository {
  const states = new Map<string, FaithfulState>();
  const key = (scope: FaithfulScope) => JSON.stringify([identity(), scope.kind, scope.id]);
  return { persistent: false,
    async get(scope) { return states.get(key(scope)) ?? { revision: 0, entries: {}, bytes: 0 }; },
    async put(scope, input) {
      const old = await this.get(scope);
      if (input.baseRevision !== old.revision) throw new FaithfulConflict();
      const entries = applyFaithfulPatch(old.entries, input), revision = old.revision + 1;
      const bytes = Object.entries(entries).reduce((total, [name, value]) => total + utf8Bytes(name) + utf8Bytes(value), 0);
      states.set(key(scope), { entries, revision, bytes });
      return { revision };
    },
  };
}
const path = (scope: FaithfulScope) => '/api/v1/faithful-state/' + encodeURIComponent(scope.kind) + '/' + encodeURIComponent(scope.id);
export const restFaithfulRepository: FaithfulStateRepository = {
  persistent: true,
  async get(scope) {
    const options = await BaseApi.getOptions(undefined);
    return (await axios.get<FaithfulState>(apiAzureUrl() + path(scope), options)).data;
  },
  async put(scope, input) {
    try {
      const options = await BaseApi.getOptions(undefined);
      return (await axios.put<{ revision: number }>(apiAzureUrl() + path(scope), JSON.stringify(input), options)).data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 409) throw new FaithfulConflict();
      throw error;
    }
  },
};
